
import LoginBox from '@/components/Entrance/Login/LoginBox.vue';
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'Login',
  components: {
    LoginBox,
  },
  setup() {},
});
